import { useEffect } from 'react';

export const useContactInfoEffects = ({
  formik,
  practice,
  setHeaderButtonProps,
  addFooterActions,
  orchestratorLoading,
  mutateTwilioNumber,
  setTwilioError,
  onNext
}) => {
  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Continue',
        onClick: async () => {
          if (formik.dirty || formik.isValid) {
            await formik.submitForm();
          } else {
            onNext();
          }
        },
        isDisabled: orchestratorLoading || (!formik.isValid && formik.dirty)
      }
    ]);
  }, [formik.isValid, formik.dirty, orchestratorLoading, onNext]);

  useEffect(() => {
    if (practice?.id && !practice?.twilio_phone) {
      const hasPracticeAddress = Boolean(practice?.practiceAddress?.address_ln_1);

      if (!hasPracticeAddress) {
        setTwilioError('Unable to generate number due to missing practice address');
        return;
      }

      setTwilioError(null);
      mutateTwilioNumber();
    }
  }, [practice?.id, practice?.twilio_phone, practice?.practiceAddress?.address_ln_1]);
};
